import { newTagI, tagI } from "@/interfaces/Photo";
import { notifyError } from "@/utils/NotificationFunctions";
import axios from "axios";
import { celebApi } from "./api";
import { ReportedSchema } from "@/interfaces/reported/reported-schema";

export async function viewImage(photoId: string, userId: string | null) {
  return axios
    .post(`${celebApi}/user/viewImage`, {
      photoId: photoId,
      userId,
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      notifyError("Connection error");
      return error;
    });
}

export async function getAuthorById(authorId: string) {
  return axios
    .post(`${celebApi}/user/photoAuthor/${authorId}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      notifyError("Connection error");
      return error;
    });
}
export async function getCommentsByPhotoId(photoId: string) {
  return axios
    .get(`${celebApi}/user/getComment`, {
      params: { photoId },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      notifyError("Connection error");
      return error;
    });
}
export async function getDiscussionsByPhotoId(photoId: string) {
  return axios
    .get(`${celebApi}/user/getDiscussion`, {
      params: { photoId },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      notifyError("Connection error");
      return error;
    });
}

export async function getTagsByPhotoId(photoId: string) {
  return axios
    .get(`${celebApi}/user/getPhotoTags/${photoId}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export async function newCommentPhoto(
  commentData: any,
  photoId: string,
  token: string
) {
  const httpOptions = {
    headers: {
      Authorization: token,
    },
  };

  return axios
    .post(
      `${celebApi}/user/postComment`,
      {
        photoId: photoId,
        parentCommentId: commentData.parentCommentId,
        comment: commentData.comment,
      },
      httpOptions
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export async function newDiscussionPhoto(
  commentData: any,
  photoId: string,
  token: string
) {
  const httpOptions = {
    headers: {
      Authorization: token,
    },
  };

  return axios
    .post(
      `${celebApi}/user/postDiscussion`,
      {
        photoId: photoId,
        parentCommentId: commentData.parentCommentId,
        comment: commentData.comment,
      },
      httpOptions
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export async function addTagToPhoto(
  photoId: string,
  tag: newTagI,
  token: string
) {
  const httpOptions = {
    headers: {
      Authorization: token,
    },
  };

  return axios
    .post(`${celebApi}/user/addTags`, { tag, photoId }, httpOptions)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function removeTagFromPhoto(
  photoId: string,
  tag: tagI,
  token: string
) {
  const httpOptions = {
    headers: {
      Authorization: token,
    },
  };

  return axios
    .post(`${celebApi}/user/removeTags`, { tag, photoId }, httpOptions)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function reportElement(data: ReportedSchema, token: string) {
  const httpOptions = {
    headers: {
      Authorization: token,
    },
  };
  return axios
    .post(`${celebApi}/user/report`, data, httpOptions)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function postImagesReplaced(data: FormData | any, token: string) {
  //hgz
  const httpOptions = {
    headers: {
      Authorization: token,
    },
  };
  return axios
    .post(`${celebApi}/user/createReplaceImage`, data, httpOptions)
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function like(token: string, photoId: string) {
  const httpOptions = {
    headers: {
      Authorization: token,
    },
  };

  return axios
    .post(`${celebApi}/user/like`, { idPhoto: photoId }, httpOptions)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export async function dislike(token: string, photoId: string) {
  const httpOptions = {
    headers: {
      Authorization: token,
    },
  };

  return axios
    .post(`${celebApi}/user/dislike`, { idPhoto: photoId }, httpOptions)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}
